export default "/images/vendor/flag-icons/flags/4x3/fr.svg?0313c7eacb9633130ffbfac55230c2d2";